import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBillAlt } from "@fortawesome/free-solid-svg-icons";

const BuyButton = ({ href, text }) => {
  const isExternal =
    href && (href.startsWith("http://") || href.startsWith("https://") || href.startsWith("//") || href.startsWith("mailto:"));

  if (isExternal) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-capitalize buybutton"
      >
        <FontAwesomeIcon icon={faMoneyBillAlt} /> {text}
      </a>
    );
  }

  return (
    <Link to={href || "#"} className="text-capitalize buybutton">
      <FontAwesomeIcon icon={faMoneyBillAlt} /> {text}
    </Link>
  );
};

export default BuyButton;
